module.exports = __webpack_public_path__ + "media/assets/images/curation/acc_arrow-57dbb8adfa402127d06d1fd7795e2f9f.svg";